import { Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { ChangeDetectorRef, ComponentRef, Directive, HostListener, inject, InjectionToken, input } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { CreateFilterOptions } from '@type/filter.type';
import { filter, tap } from 'rxjs';
import { FilterSideBarComponent } from '../components/filter-side-bar/filter-side-bar.component';
import { FilterHelperService } from './filter-helper/filter-helper.service';

export const FILTER_OPTIONS_TOKEN = new InjectionToken<any[]>('FILTER_OPTIONS');

@Directive({
  selector: '[openFilter]',
})
export class OpenFilterDirective {
  private overlay = inject(Overlay);

  private overlayRef: OverlayRef;

  private fhs = inject(FilterHelperService);

  private cdr = inject(ChangeDetectorRef);

  private overlayConfig: OverlayConfig = {
    width: 420,
    height: '100%',
    hasBackdrop: true,
    disposeOnNavigation: true,
    positionStrategy: this.overlay.position().global().top('0px').right('0px').bottom('0px'),
  };

  private portalRef: ComponentPortal<FilterSideBarComponent>;

  private componentRef?: ComponentRef<FilterSideBarComponent>;

  options = input.required<CreateFilterOptions | null>({ alias: 'openFilter' });

  constructor() {
    this.overlayRef = this.overlay.create(this.overlayConfig);
    this.portalRef = this.createPortal();
    this.detachAttachmentsWhenBackdropClicked();
    this.setOptions();
  }

  @HostListener('click')
  showFilter() {
    this.componentRef = this.overlayRef.attach(this.portalRef);
    this.setAttachedPortalInputs();
  }

  private createPortal() {
    return new ComponentPortal(FilterSideBarComponent, null);
  }

  private setAttachedPortalInputs() {
    this.componentRef?.setInput('overlayRef', this.overlayRef);
  }

  private detachAttachmentsWhenBackdropClicked() {
    this.overlayRef
      .backdropClick()
      .pipe(
        tap(() => {
          this.overlayRef.detach();
          this.cdr.detectChanges();
        }),
        takeUntilDestroyed(),
      )
      .subscribe();
  }

  private setOptions() {
    toObservable(this.options)
      .pipe(takeUntilDestroyed(), filter(Boolean))
      .subscribe((res) => this.fhs.set(res));
  }
}
